<script setup lang="ts">
   import { definePageMeta, useHead } from '#imports';

   definePageMeta({
      layout: 'wow-polo',
   });

   useHead({
      title: 'WOW Polo Gives Back — WOW Polo Series',
   });

   const organizations = [
      {
         name: 'Polo Museum',
         logo: '/img/polo-museum.png',
         siteUrl: 'https://polomuseum.org/',
         donateUrl: 'https://polomuseum.org/donate/',
      },
      {
         name: 'Polo Training Foundation',
         logo: '/img/polo-training-foundation.webp',
         siteUrl: 'https://polotraining.org/',
         donateUrl: 'https://polotraining.org/ways-to-give/',
      },
      {
         name: 'Polo Players Support Group',
         logo: '/img/polo-players-support-group.png',
         siteUrl: 'https://www.polosupport.com/',
         donateUrl: 'https://polotraining.org/ways-to-give/',
      },
   ];
</script>

<template>
   <div>
      <!-- Hero -->
      <section class="wow-give-back-hero relative h-[320px] bg-cover bg-center bg-no-repeat">
         <div class="absolute inset-0 bg-black/50" />
         <div class="relative flex h-full flex-col items-center justify-center px-6 text-center">
            <h1 class="mb-4 text-4xl font-bold text-white md:text-5xl lg:text-6xl">
               WOW Polo Gives Back
            </h1>
         </div>
      </section>

      <!-- Intro -->
      <section class="bg-white py-16">
         <div class="mx-auto grid max-w-6xl gap-12 px-6 lg:grid-cols-[3fr_1fr]">
            <p class="leading-relaxed text-gray-700">
               WOW Polo Series is fortunate to be supported by so many that we believe giving back to the community that is a special part of our lives is a fundamental action of being part of a community. WOW Polo will directly contribute and seeks to bring awareness to the incredible organizations below. Please take a moment to familiarize yourself with their purpose and if it strikes a chord then please consider sending your own donation. Thank you very much for being part of WOW Polo and hopefully together we can make a positive impact on peoples' lives.
            </p>
            <div class="flex items-start justify-center lg:justify-end">
               <img
                  src="/img/wow-polo-logo.webp"
                  alt="WOW Polo Series"
                  class="size-40 rounded-full object-cover" />
            </div>
         </div>
      </section>

      <!-- Organizations -->
      <section class="bg-gray-50 py-16">
         <div class="mx-auto grid max-w-6xl gap-12 px-6 sm:grid-cols-2 md:grid-cols-3">
            <div
               v-for="org in organizations"
               :key="org.name"
               class="flex flex-col items-center text-center">
               <a
                  :href="org.siteUrl"
                  target="_blank"
                  rel="noopener"
                  class="flex h-56 items-center justify-center">
                  <img
                     :src="org.logo"
                     :alt="org.name"
                     class="max-h-full max-w-full object-contain" />
               </a>
               <a
                  :href="org.donateUrl"
                  target="_blank"
                  rel="noopener"
                  class="wow-give-back-btn mt-6 rounded-md px-6 py-2 text-sm font-semibold uppercase tracking-wide text-white transition-opacity hover:opacity-90">
                  Donate Now
               </a>
            </div>
         </div>
      </section>
   </div>
</template>

<style scoped>
   .wow-give-back-hero {
      background-image: url('/img/home-page-hero-bg.webp');
   }

   .wow-give-back-btn {
      background-color: #5cc8d9;
   }
</style>
